<template>
  <a name="about"></a>
  <div class="bg-verde-md conteudo_mov">
    <div class="content conteudo_mov2 border-log mt-5">
      <div class="row border-log">

        <div class="col-4 col-md-4">
          <img :src="'logo-awa-footer.svg'" class="footer_logo" />
        </div>

        <div class="col-4 col-md-4 amarelo">
&nbsp;

        </div>

        <div class="col-4 col-md-4 amarelo">

          <center>
        <b><small><small>Follow Us:</small></small></b>
        &nbsp; &nbsp; &nbsp;
        <a href="https://www.linkedin.com/company/awapurewater" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="31.5" height="31.5" viewBox="0 0 31.5 31.5">
            <path id="Icon_awesome-linkedin" data-name="Icon awesome-linkedin" d="M29.25,2.25H2.243A2.26,2.26,0,0,0,0,4.521V31.479A2.26,2.26,0,0,0,2.243,33.75H29.25a2.266,2.266,0,0,0,2.25-2.271V4.521A2.266,2.266,0,0,0,29.25,2.25Zm-19.73,27H4.852V14.217H9.527V29.25ZM7.186,12.164A2.707,2.707,0,1,1,9.893,9.457a2.708,2.708,0,0,1-2.707,2.707ZM27.021,29.25H22.352V21.938c0-1.744-.035-3.987-2.426-3.987-2.433,0-2.805,1.9-2.805,3.86V29.25H12.452V14.217h4.479V16.27h.063a4.917,4.917,0,0,1,4.423-2.426c4.725,0,5.6,3.115,5.6,7.165Z" transform="translate(0 -2.25)" fill="#e0d0a6" />
          </svg>
        </a>
        &nbsp; &nbsp; &nbsp;
        <a href="https://www.instagram.com/awapurewater/" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" width="31.518" height="31.51" viewBox="0 0 31.518 31.51">
            <path id="Icon_awesome-instagram" data-name="Icon awesome-instagram"
              d="M15.757,9.914a8.079,8.079,0,1,0,8.079,8.079A8.066,8.066,0,0,0,15.757,9.914Zm0,13.331a5.252,5.252,0,1,1,5.252-5.252,5.262,5.262,0,0,1-5.252,5.252ZM26.051,9.584A1.884,1.884,0,1,1,24.166,7.7,1.88,1.88,0,0,1,26.051,9.584ZM31.4,11.5a9.325,9.325,0,0,0-2.545-6.6,9.387,9.387,0,0,0-6.6-2.545c-2.6-.148-10.4-.148-13,0a9.373,9.373,0,0,0-6.6,2.538,9.356,9.356,0,0,0-2.545,6.6c-.148,2.6-.148,10.4,0,13a9.325,9.325,0,0,0,2.545,6.6,9.4,9.4,0,0,0,6.6,2.545c2.6.148,10.4.148,13,0a9.325,9.325,0,0,0,6.6-2.545,9.387,9.387,0,0,0,2.545-6.6c.148-2.6.148-10.392,0-12.994ZM28.041,27.281a5.318,5.318,0,0,1-3,3c-2.074.823-7,.633-9.288.633s-7.221.183-9.288-.633a5.318,5.318,0,0,1-3-3c-.823-2.074-.633-7-.633-9.288s-.183-7.221.633-9.288a5.318,5.318,0,0,1,3-3c2.074-.823,7-.633,9.288-.633s7.221-.183,9.288.633a5.318,5.318,0,0,1,3,3c.823,2.074.633,7,.633,9.288S28.863,25.214,28.041,27.281Z"
              transform="translate(0.005 -2.238)" fill="#e0d0a6" />
          </svg>
        </a>
      </center>

        </div>


      </div>
    </div>
  </div>


  <div class="bg-verde-esc">
  <div class="col-12 verde-esc div-rodape">
    <center>
      <small><small class="normal">
        AWA DA AMAZÔNIA LTDA - MANAUS - AM - BRAZIL - CNPJ: 60.313.911/0001-09 - E-MAIL: CONTACT@AWAPUREWATER.COM - WHATSAPP: +55 (11) 993 330 218
      </small></small>
      <small><small class="mobile">
        AWA DA AMAZÔNIA LTDA - MANAUS - AM - BRAZIL
        <br>CNPJ: 60.313.911/0001-09
        <br>E-MAIL: CONTACT@AWAPUREWATER.COM
        <br>WHATSAPP: +55 (11) 993 330 218
      </small></small>
    </center>
  </div>
</div>


</template>





<script>
export default {
}
</script>

<style scoped>
:root {
  --cream: #E0D0A6;
  --blue: #6FD0E7;
  --green: #536D3F;
  --mid-green: #475C37;
  --dark-green: #3D4D31;
  --object-sans: 'Object Sans', Arial, Helvetica, sans-serif;
}


.normal {
  display: block;
}

.mobile {
  display: none;
}


.div-rodape {
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}


.inputx {
  font-family: MinhaFonte;
  background-color: transparent;
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 1px solid #e0d0a6;
  font-size: 2rem;
  letter-spacing: 0.06rem;
  line-height: 2.8rem;
  margin-bottom: 0.4rem;
  width: 50%;
}

.inputx::placeholder {
  color: #e0d0a6;
  opacity: 0.25;
}

.btemail {
  font-family: 'Object Sans';
  color: var(--cream);
  padding: 10px 10px 3px 10px;
  margin-left: 10px;
  border: 1px solid #e0d0a6;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 1.4rem;
  letter-spacing: 0.28rem;
  line-height: 1.9rem;
  background-color: transparent;
}

.btemail:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
}



.verde-esc {
  color: #b19c69;
}

.border-log {
      border: 0px solid rgb(0, 0, 255);
  }

.p-4 { padding: 1.5rem; }

.left {
  text-align: left;
}

.conteudo_mov {
  display: flex; /* Se já não estiver definido */
  justify-content: center;
}

.conteudo_mov2 {
    max-width: 172rem; 
    transition: max-width 0.3s ease-in-out;
    text-align: left;
    flex-grow: 1
}

.bg-verde-md {
  padding-top: 8rem; /* Removi o margin */
  padding-bottom: 8rem; /* Removi o margin */
  background-color: var(--mid-green);
  width: 100%; /* Garante que o fundo verde ocupe toda a largura da tela */
}

.cor-azul {
  color: var(--blue);
}

.amarelo {
  color: var(--cream);
}

h1 {
  font-family: var(--object-sans);
  font-size: 6rem;
  font-weight: 400;
  letter-spacing: 0.06rem;
}


.f-4 {
    font-size: 2.2rem;
    letter-spacing: 0.06rem;
    line-height: 2.8rem;
    margin-bottom: 2rem;
  }

  
.content {
  padding: 4rem; /* Reduzi o padding para 2rem, ajustando para não ficar tão grande */
  margin: 0; /* Removi o margin */
  text-align: left;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.col-4 {
  flex: 0 0 33%;
  max-width: 33%;
}

@media screen and (max-width: 640px) {

  .normal {
    display: none; /* Esconde o formato grande */
  }
  
  .mobile {
    display: block; /* Exibe o formato pequeno */
    text-align: left;
  }


  h1 {
    font-size: 4rem;
  }

  .p-4 { padding: 3rem; }

  .f-4 {
    font-size: 2.2rem;
    letter-spacing: 0.06rem;
    line-height: 2.8rem;
    margin-bottom: 2rem;
  }

  .content {
    padding: 1rem; /* Ajustei o padding para ser menor em telas pequenas */
    margin: 0;
    text-align: left;
  }

  .row {
    flex-direction: column;
    text-align: center;
  }

  .col-md-4 {
    padding-top: 8rem; /* Ajustei o padding para ser menor em telas pequenas */
    flex: 0 0 100%;
    max-width: 100%;
  }

  .footer_logo {
    max-width: 90%;
  }


}
</style>


<!-- center>
  <small><small>Sign up to stay informed about our updates.</small></small><br /><br />
  <input v-model="email" type="email" class="inputx amarelo" placeholder="your email" />
  <button class="btemail" @click="sendEmail">ok</button>
</center -->